__turbopack_context__.v({
  "authorDetails": "testimonial-module-scss-module__ghEEkG__authorDetails",
  "authorImage": "testimonial-module-scss-module__ghEEkG__authorImage",
  "authorName": "testimonial-module-scss-module__ghEEkG__authorName",
  "authorSubtitle": "testimonial-module-scss-module__ghEEkG__authorSubtitle",
  "darkBackground": "testimonial-module-scss-module__ghEEkG__darkBackground",
  "exclude-lg": "testimonial-module-scss-module__ghEEkG__exclude-lg",
  "exclude-md": "testimonial-module-scss-module__ghEEkG__exclude-md",
  "featured": "testimonial-module-scss-module__ghEEkG__featured",
  "gridContainer": "testimonial-module-scss-module__ghEEkG__gridContainer",
  "hasAuthorImage": "testimonial-module-scss-module__ghEEkG__hasAuthorImage",
  "quote": "testimonial-module-scss-module__ghEEkG__quote",
  "wrapper": "testimonial-module-scss-module__ghEEkG__wrapper",
});
